import { Link } from "react-router-dom";

export type Crumb = { label: string; to?: string };

export default function PageHeader({
  title,
  subtitle,
  crumbs,
  eyebrow,
}: {
  title: string;
  subtitle?: string;
  crumbs: Crumb[];
  eyebrow?: string;
}) {
  return (
    <section className="relative overflow-hidden border-b border-background-300/40 bg-background-100 pt-28 md:pt-32">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-500/15 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 bottom-0 h-60 w-60 rounded-full bg-accent-500/15 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-4 pb-10 md:px-6 md:pb-14">
        <nav aria-label="面包屑" className="mb-5 flex flex-wrap items-center gap-2 text-sm text-foreground-500">
          <Link to="/" className="flex items-center gap-1 hover:text-primary-400">
            <i className="ri-home-4-line" /> 首页
          </Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-2">
              <i className="ri-arrow-right-s-line" />
              {c.to ? (
                <Link to={c.to} className="hover:text-primary-400">
                  {c.label}
                </Link>
              ) : (
                <span className="text-foreground-700">{c.label}</span>
              )}
            </span>
          ))}
        </nav>
        {eyebrow && (
          <p className="mb-3 flex items-center gap-2 text-sm font-bold text-primary-400">
            <span className="h-px w-8 bg-primary-500" />
            {eyebrow}
          </p>
        )}
        <h1 className="font-heading text-3xl text-foreground-950 md:text-4xl">{title}</h1>
        {subtitle && (
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}